import Badge, { BadgeSize, BadgeVariant } from '../../atoms/badge/Badge';
import type { SurveyStatus } from './types';

const STATUS_MAP: Record<SurveyStatus, { variant: BadgeVariant; label: string }> = {
  upcoming: { variant: BadgeVariant.INFO, label: 'À venir' },
  active: { variant: BadgeVariant.SUCCESS, label: 'Actif' },
  expired: { variant: BadgeVariant.DEFAULT, label: 'Expiré' },
};

type Props = { status: SurveyStatus };

export function SurveyStatusBadge({ status }: Props) {
  const { variant, label } = STATUS_MAP[status];
  return (
    <Badge variant={variant} size={BadgeSize.LARGE}>
      {label}
    </Badge>
  );
}
